import React from 'react';
export function PrivateCinema() {
  return <section className="w-full bg-white py-12" data-id="element-132">
      <div className="max-w-6xl mx-auto px-6" data-id="element-133">
        <div className="lg:pl-[100px]" data-id="element-134">
          {/* Hero heading */}
          <div className="mb-16" data-id="element-135">
            <h1 className="text-3xl font-normal text-[#707070] tracking-wide mb-3" data-id="element-136">
              Privátní kino
            </h1>
            <p className="text-lg text-[#999] font-light" data-id="element-137">
              Vlastní kinosál, ve vašem domě
            </p>
          </div>

          {/* Content blocks */}
          <div className="space-y-16" data-id="element-138">
            {/* Block 1 - Intro with hero image */}
            <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-start" data-id="element-139">
              <div className="space-y-6" data-id="element-140">
                <p className="text-[#707070] leading-relaxed" data-id="element-141">
                  Stačí jen pár kroků, a jste v jiném světě. S komfortem, který
                  nenabídne běžné domácí kino ve vašem obývacím pokoji, ani ten
                  nejlepší multikino.
                </p>
                <p className="text-[#707070] leading-relaxed" data-id="element-142">
                  Perfektně sladěný zvuk a velký obraz, začátek představení
                  právě v ten okamžik, který si vy zvolíte, pohodlná křesla v
                  první řadě s elektrickým ovládáním a s možností pohybu dle
                  scény ve filmu, nabídka filmů z vašeho AV serveru, 3D,
                  občerstvení z chladícího boxu, přímo vedle křesla a komfortní
                  ovládání.
                </p>
              </div>
              <div className="w-full" data-id="element-143">
                <img src="https://cdn.magicpatterns.com/uploads/rftkpx31Vs1F5uDxr2722R/projects_main_107.jpg" alt="Privátní kinosál s velkým plátnem" className="w-full h-auto grayscale" data-id="element-144" />
              </div>
            </div>

            {/* Block 2 - Design & comfort */}
            <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-start" data-id="element-145">
              <div className="w-full lg:order-1" data-id="element-146">
                <img src="https://cdn.magicpatterns.com/uploads/49qUM5gEnyLjxgwku3MhhV/kino09870.png" alt="Luxusní kožená křesla v kinosálu" className="w-full h-auto grayscale" data-id="element-147" />
              </div>
              <div className="space-y-6 lg:order-2" data-id="element-148">
                <p className="text-[#707070] leading-relaxed" data-id="element-149">
                  Vše zabalené do designu na míru, přesně podle vašeho vkusu.
                  Domácí kinosál je nekompromisním řešením domácí zábavy.
                </p>
                <p className="text-[#707070] leading-relaxed" data-id="element-150">
                  První, co potřebujete, kromě peněz, pokud si chcete pořídit
                  vlastní domácí kinosál, je vhodný prostor. Teoreticky
                  neexistuje omezení, pokud jde o maximální rozměry, ale asi si
                  nebudete pořizovat kinosál pro 300 lidí.
                </p>
              </div>
            </div>

            {/* Block 3 - Dimensions & CTA */}
            <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-start" data-id="element-151">
              <div className="space-y-6" data-id="element-152">
                <p className="text-[#707070] leading-relaxed" data-id="element-153">
                  Minimální rozměry místnosti už své limity mají. Platí, že čím
                  menší místnost, tím menší obraz a také menší možnosti zvukové
                  aparatury. Domácí kinosál by tedy neměl mít méně, než 6×5
                  metrů, ale ideální rozměry se pohybují někde mezi 6×8 až
                  9x10m. Pokud chcete kinosál spojit s barem, či kulečníkem, je
                  samozřejmě třeba nějaké ty metry přidat.
                </p>
                <p className="text-[#707070] leading-relaxed" data-id="element-154">
                  Výška místnosti před úpravami je pak ideální mezi 3-4m
                </p>
                <p className="text-[#707070] leading-relaxed text-lg font-light mt-4" data-id="element-155">
                  Svěřte se do naší péče, postaráme se o vás a splníme váš sen.
                  Do detailu.
                </p>
              </div>
              <div className="w-full" data-id="element-156">
                <img src="https://cdn.magicpatterns.com/uploads/rqgiyYur9kTJFebpeBv2FQ/LANGARD_kinosal-2.jpg" alt="Kinosál s podsvícenými stupni a křesly" className="w-full h-auto grayscale" data-id="element-157" />
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>;
}